import React from 'react';
import WorkflowLandingPage from '../components/WorkflowLandingPage';
import { JobType } from '../graphql/types';

/**
 * DueDiligenceLandingPage - Wrapper component for Due Diligence workflow
 * 
 * Renders the shared WorkflowLandingPage with JobType.DD to display
 * and manage Due Diligence jobs.
 * 
 * Requirements: 3.1, 14.1
 */
const DueDiligenceLandingPage: React.FC = () => {
  return <WorkflowLandingPage jobType={JobType.DD} />;
};

export default DueDiligenceLandingPage;
